export enum MedicalSource {
    Diagnosis = 1, 
    Medication = 2, 
    ClinicalDocumentation = 3,
    ChiefComplaint = 4,
    VitalSign = 5
}